"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const format = (input) => new Parser(input).format();
// eslint-disable-next-line no-useless-escape
const listElement = /^([ \t]*)[\*\-] /;
// eslint-disable-next-line no-useless-escape
const elementRegex = /^([ \t])*[\-\*] /;
const quoteRegex = /^([ \t]*)(>|&gt;)/;
const endEmphasis = /_($|[ *_])/;
const endStrong = /\*($|[ *_])/;
class Parser {
    constructor(input) {
        this.input = input;
        this.out = '';
        this.pos = 0;
        this.indent = 0;
    }
    listElementDepth(input) {
        const match = input.match(elementRegex);
        if (match === null) {
            return -1;
        }
        else if (typeof match[1] === 'string') {
            return match[1].length;
        }
        else {
            return 0;
        }
    }
    quoteElementDepth(input) {
        const match = input.match(quoteRegex);
        if (match === null) {
            return -1;
        }
        else if (typeof match[1] === 'string') {
            return match[1].length;
        }
        else {
            return 0;
        }
    }
    write(str) {
        this.out += str;
        return this;
    }
    format() {
        while (this.pos < this.input.length) {
            this.skipEmptyLines();
            if (this.listElementDepth(this.remaining()) != -1) {
                this.ul();
            }
            else if (this.quoteElementDepth(this.remaining()) != -1) {
                this.quote();
            }
            else {
                this.paragraph();
            }
        }
        return this.out;
    }
    paragraph() {
        this.write('<p>');
        this.indent++;
        while (this.pos < this.input.length) {
            this.nl();
            const line = this.takeLine();
            this.write(this.text(line));
            if (this.isEmptyLine()) {
                break;
            }
            if (this.listElementDepth(this.remaining()) != -1) {
                break;
            }
            if (this.quoteElementDepth(this.remaining()) != -1) {
                break;
            }
            this.write('<br/>');
        }
        this.indent--;
        this.nl();
        this.write('</p>');
        this.nl();
    }
    text(s) {
        s = s.trim();
        let output = '', i = 0, canStartStyle = true;
        while (i < s.length) {
            const char = s[i];
            if (char == '*' || char == '_') {
                i++;
                if (canStartStyle) {
                    const match = s.substring(i).match(char == '*' ? endStrong : endEmphasis);
                    if (match !== null && match.index > 0) {
                        const tag = char == '*' ? 'strong' : 'em';
                        output += `<${tag}>`;
                        output += this.text(s.substring(i, i + match.index));
                        output += `</${tag}>`;
                        i += match.index + 1;
                        continue;
                    }
                }
                output += char;
            }
            else {
                const start = i;
                while (i < s.length && s[i] !== '*' && s[i] !== '_') {
                    i++;
                }
                output += s.substring(start, i);
            }
            canStartStyle = s[i - 1] == ' ' || s[i - 1] == '\t';
        }
        return output;
    }
    ul() {
        this.write('<ul>');
        this.indent++;
        let match = this.remaining().match(listElement);
        while (match !== null) {
            this.nl();
            this.pos += match[0].length;
            this.write(`<li>${this.text(this.takeLine())}</li>`);
            match = this.remaining().match(listElement);
        }
        this.indent--;
        this.nl();
        this.write('</ul>');
        this.nl();
    }
    quote() {
        this.write('<blockquote>');
        this.indent++;
        let match = this.remaining().match(quoteRegex);
        while (match !== null) {
            this.nl();
            this.pos += match[0].length;
            this.write(this.text(this.takeLine()));
            this.write('<br/>');
            match = this.remaining().match(quoteRegex);
        }
        this.indent--;
        this.nl();
        this.write('</blockquote>');
        this.nl();
    }
    skipEmptyLines() {
        let i = this.pos;
        while (i < this.input.length) {
            const char = this.input[i];
            if (char === '\n') {
                i++;
                this.pos = i;
            }
            else if (char === ' ' || char === '\t') {
                i++;
            }
            else {
                return;
            }
        }
    }
    remaining() {
        return this.input.substring(this.pos);
    }
    nl() {
        this.write('\n').write('  '.repeat(this.indent));
    }
    takeLine() {
        const end = this.remaining().indexOf('\n');
        if (end === -1) {
            const ret = this.remaining();
            this.pos = this.input.length;
            return ret;
        }
        const start = this.pos;
        this.pos += end + 1;
        return this.input.substring(start, start + end);
    }
    isEmptyLine() {
        let i = this.pos;
        while (i < this.input.length) {
            const char = this.input[i];
            if (char === '\n') {
                return true;
            }
            if (char != ' ' && char != '\t') {
                return false;
            }
            i++;
        }
        return true;
    }
}
exports.Parser = Parser;
exports.default = format;
